import { render, staticRenderFns } from "./SelectPackage.vue?vue&type=template&id=2f44ed1a&"
import script from "./SelectPackage.vue?vue&type=script&lang=js&"
export * from "./SelectPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports